import { challengeComponent } from './content';
import React, { useCallback, useState } from 'react';
import styles from './index.module.scss';
import HeadContainer from '../../head-container';
import classNames from 'classnames';

const handleAnswerIndex = (index) => {
  const letter = () => {
    switch (index) {
      case 0:
        return 'a';
      case 1:
        return 'б';
      case 2:
        return 'в';
      case 3:
        return 'г';
      default:
        return 'a';
    }
  };

  return <div className={styles.letterIndex}>{letter()}</div>;
};

const GuessCityChallenge = ({
  setScreenNumber,
  challengeId,
  afterResultButtonScreen,
  backgroundImage
}) => {
  const challengeList = challengeComponent.find(
    (item) => item?.id === challengeId
  );
  const [challengeStep, setChallengeStep] = useState(0);
  const [selectQuestion, setSelectQuestion] = useState(
    challengeList?.questions[0]
  );
  const [correctAnswerValue, setCorrectAnswerValue] = useState(0);
  const [isWelcomeScreen, setIsWelcomeScreen] = useState(true);
  const [isResultScreen, setIsResultScreen] = useState(false);
  const [isAfterResultScreen, setIsAfterResultScreen] = useState(false);
  const [answers, setAnswers] = useState([]);

  const isStepAnswered = !!answers[challengeStep];

  const onAnswerClick = useCallback(
    (value) => {
      // Lock the answer once picked so the reveal is one-shot.
      if (answers[challengeStep]) return;
      setAnswers((prev) => ({ ...prev, [challengeStep]: value }));
    },
    [answers, challengeStep]
  );

  const onFinishClick = () => {
    const correctAnswerCount = Object.values(answers).filter(
      (item) => item?.isCorrect
    )?.length;
    const totalQuestions = challengeList?.questions?.length;
    setCorrectAnswerValue(
      challengeList?.resultList[
        correctAnswerCount === totalQuestions
          ? 2
          : correctAnswerCount >= 4
            ? 1
            : 0
      ]
    );
    setIsResultScreen(true);
  };

  return (
    challengeList && (
      <div
        className={styles.wrapper}
        style={{
          backgroundImage: backgroundImage
            ? backgroundImage
            : `url(${challengeList.backgroundImage})`
        }}
        id={challengeId}
      >
        <div style={{ padding: '20px 30px 0' }}>
          <HeadContainer setScreenNumber={setScreenNumber} id={challengeId} />
        </div>
        {isWelcomeScreen && !isResultScreen && (
          <div className={styles.welcomeContainer}>
            <div className={styles.headContainer}>
              <img
                src={challengeList?.welcomeBackgroundIcon}
                alt="welcome-icon"
              />
              <p className={styles.title}>{challengeList?.title}</p>
            </div>
            <p className={styles.description}>{challengeList?.description}</p>
            <button onClick={() => setIsWelcomeScreen(false)}>
              {challengeList?.startButtonTitle}
            </button>
          </div>
        )}
        {!isWelcomeScreen && !isResultScreen && !isAfterResultScreen && (
          <div className={styles.challengeContainer}>
            <div className={styles.stepToolbar}>
              {challengeList.questions.map((item, index) => (
                <div
                  key={index}
                  className={classNames(
                    styles.stepItem,
                    index === challengeStep && styles.activeStepItem
                  )}
                />
              ))}
            </div>
            <div className={styles.questionContainer}>
              <p className={styles.title}>{selectQuestion?.title}</p>
              {selectQuestion?.image ? (
                <img
                  className={styles.photo}
                  src={selectQuestion.image}
                  alt="city"
                />
              ) : (
                <div className={styles.photoMock} />
              )}
              {isStepAnswered ? (
                <div className={styles.answerReveal}>
                  <p className={styles.revealTitle}>
                    {answers[challengeStep]?.isCorrect
                      ? selectQuestion?.correctText
                      : selectQuestion?.wrongText}
                  </p>
                  <p className={styles.revealDescription}>
                    {selectQuestion?.description}
                  </p>
                </div>
              ) : (
                <div className={styles.answerList}>
                  {selectQuestion?.answerList?.map((item, index) => (
                    <div
                      key={item?.id}
                      className={styles.answerItem}
                      onClick={() =>
                        onAnswerClick({
                          answerId: item?.id,
                          answer: item?.title,
                          isCorrect: item?.isCorrect
                        })
                      }
                    >
                      {handleAnswerIndex(index)}
                      <p>{item?.title}</p>
                    </div>
                  ))}
                </div>
              )}
            </div>
            <div className={styles.buttonContainer}>
              <div
                className={styles.leftButton}
                onClick={() => {
                  if (challengeStep > 0) {
                    setChallengeStep(challengeStep - 1);
                    setSelectQuestion(
                      challengeList?.questions[challengeStep - 1]
                    );
                  } else {
                    setIsWelcomeScreen(true);
                    setSelectQuestion(challengeList?.questions[0]);
                    setChallengeStep(0);
                    setIsResultScreen(false);
                    setAnswers([]);
                  }
                }}
              >
                <span>Назад</span>
              </div>
              {isStepAnswered && (
                <div
                  className={styles.rightButton}
                  onClick={() => {
                    if (challengeStep + 1 >= challengeList?.questions?.length) {
                      onFinishClick();
                      return;
                    }
                    setChallengeStep(challengeStep + 1);
                    setSelectQuestion(
                      challengeList?.questions[challengeStep + 1]
                    );
                  }}
                >
                  <span>Далі</span>
                </div>
              )}
            </div>
          </div>
        )}
        {isResultScreen && !isWelcomeScreen && (
          <div className={styles.resultContainer}>
            <p className={styles.headResultTitle}>
              {correctAnswerValue?.title}
            </p>
            <img src={correctAnswerValue?.image} alt="result-image" />
            <div className={styles.resultPanel}>
              <p className={styles.resultSubtitle}>
                {correctAnswerValue?.subtitle}
              </p>
              <p className={styles.description}>
                {correctAnswerValue?.description}
              </p>
            </div>
            <button
              onClick={() => {
                setChallengeStep(0);
                setSelectQuestion(challengeList?.questions[0]);
                setCorrectAnswerValue(0);
                setIsResultScreen(false);
                setIsAfterResultScreen(true);
              }}
            >
              <span>Далі</span>
            </button>
          </div>
        )}
        {isAfterResultScreen && !isWelcomeScreen && !isResultScreen && (
          <div className={styles.afterResultContainer}>
            <img
              src={challengeList?.afterResultContent?.image}
              alt="after-result-image"
            />
            <div className={styles.afterResultPanel}>
              <p className={styles.title}>
                {challengeList?.afterResultContent?.title}
              </p>
              <p className={styles.description}>
                {challengeList?.afterResultContent?.description}
              </p>
            </div>
            <button
              onClick={() => {
                setChallengeStep(0);
                setSelectQuestion(challengeList?.questions[0]);
                setCorrectAnswerValue(0);
                setIsResultScreen(false);
                setIsAfterResultScreen(false);
                setIsWelcomeScreen(true);
                setAnswers([]);
                afterResultButtonScreen();
              }}
            >
              <span>{challengeList?.afterResultContent?.nextButtonText}</span>
            </button>
          </div>
        )}
      </div>
    )
  );
};

export default GuessCityChallenge;
